module.exports = __webpack_public_path__ + "img/user_gy.1ee1442.svg";